import { Avatar, Tooltip } from 'antd';
import { AvatarSize } from 'antd/es/avatar/SizeContext';
import { memo } from 'react';
import { stringToColor } from 'utils';

interface UserAvatarProps {
  email: string;
  size: AvatarSize;
}

function UserAvatar({ email, size }: UserAvatarProps) {
  return (
    <Tooltip title={email}>
      <Avatar
        className="pointer"
        style={{ backgroundColor: stringToColor(email), verticalAlign: 'middle' }}
        size={size}
      >
        {email[0] + email[email.indexOf('@') - 1]}
      </Avatar>
    </Tooltip>
  );
}

export default memo(UserAvatar);
